/*
  Katalog: Filter und Sortierung schicken sich bei Aenderung selbst ab.

  Den zugeklappten Zustand der Filterleiste setzt das Stylesheet
  (@media (scripting: enabled) and (max-width: 989px)), nicht dieses Modul – sonst
  rueckt das Raster nach, sobald das Modul geladen ist. Hier wird nur umgeschaltet.
*/
class EratecKatalog extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('.er-katalog__filter');
    this.leiste = this.querySelector('[data-filter-leiste]');
    this.schalter = this.querySelector('[data-filter-schalter]');
    this.sortierung = this.querySelector('[data-sortierung]');

    if (this.form) {
      this.form.addEventListener('change', (event) => {
        // Preisfelder erst beim Verlassen abschicken, nicht bei jedem Zeichen.
        if (event.target instanceof HTMLInputElement && event.target.hasAttribute('data-preisfeld')) return;
        this.form.requestSubmit();
      });

      this.form.addEventListener('focusout', (event) => {
        const feld = event.target;
        if (feld instanceof HTMLInputElement && feld.hasAttribute('data-preisfeld') && feld.value !== feld.defaultValue) {
          this.form.requestSubmit();
        }
      });

      this.form.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' && event.target instanceof HTMLInputElement) {
          event.preventDefault();
          this.form.requestSubmit();
        }
      });

      // Leere Preisfelder nicht als leere Parameter mitschicken.
      this.form.addEventListener('formdata', (event) => {
        for (const [name, wert] of [...event.formData.entries()]) {
          if (wert === '') event.formData.delete(name);
        }
      });
    }

    this.sortierung?.addEventListener('change', () => {
      if (this.form) {
        this.form.requestSubmit();
        return;
      }
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.sortierung.value);
      url.searchParams.delete('page');
      window.location.assign(url.toString());
    });

    if (this.schalter && this.leiste) {
      // Browser ohne das Media-Feature "scripting" klappen nichts ein, dann ist der
      // Knopf sinnlos (die Leiste steht offen da).
      if (!window.matchMedia('(scripting: enabled)').matches) {
        this.schalter.hidden = true;
        return;
      }
      const schmal = window.matchMedia('(max-width: 989px)');
      this.schalter.addEventListener('click', () => {
        const offen = this.leiste.toggleAttribute('data-offen');
        this.schalter.setAttribute('aria-expanded', String(offen));
        if (offen && schmal.matches) this.leiste.querySelector('input')?.focus();
      });
    }
  }
}

if (!customElements.get('eratec-katalog')) {
  customElements.define('eratec-katalog', EratecKatalog);
}
